import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable } from 'rxjs';

import { filter, take } from 'rxjs/operators';
import { AuthResponse, LoginResponseData } from '../model/user-interfaces';
import { ChatErrorService } from './chat-error.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private refreshingToken = false;
  private refreshedToken = false;
  private tokenSubject = new BehaviorSubject<any>(null);

  constructor(private router: Router,
    private apiService: ApiService,
    private ioClient: SocketService,
  ) { }



  setUser(loginRes: AuthResponse) {
    localStorage.setItem(environment.CHAT_USER_KEY, JSON.stringify(loginRes?.data));
    if (loginRes?.data?.authToken) {
      localStorage.setItem(environment.X_Auth_Token, loginRes?.data?.authToken);
    }
    if (loginRes?.data?.refreshToken) {
      localStorage.setItem(environment.X_Refresh_Token, loginRes?.data?.refreshToken);
    }
    if (loginRes?.data?.user?.userId) {
      localStorage.setItem(environment.X_User_Id, JSON.stringify(loginRes?.data?.user?.userId));
    }
  }

  getUser(): LoginResponseData {
    return JSON.parse(localStorage.getItem(environment.CHAT_USER_KEY));
  }

  get isAdmin() {
    return this.getUser()?.user?.isOwner;
  }

  isUserLoggedIn(): boolean {
    return !!localStorage.getItem(environment.CHAT_USER_KEY);
  }

  refreshChatToken(token = '') {
    return this.apiService.refreshChatToken(token);
  }

  logout() {
    localStorage.clear();
    // this.router.navigate(['/']);
    location.href = '/';
  }

  startTokenRefresh(): void {
    this.refreshingToken = true;
    this.tokenSubject.next(null);
  }

  completeTokenRefresh(newToken) {
    this.refreshingToken = false;
    this.tokenSubject.next(newToken);
  }

  failTokenRefresh(): void {
    this.refreshingToken = false;
    this.tokenSubject.next(null);
  }

  get isTokenRefreshed(): boolean {
    return this.refreshedToken;
  }

  waitForToken(): Observable<any> {
    return this.tokenSubject.asObservable().pipe(
      filter(token => token !== null),
      take(1)
    );
  }

  isRefreshing(): boolean {
    return this.refreshingToken;
  }

}
